import { ConnectionTypes } from '~/api/types/connectionData.ts';
import { AgentConnectToolData } from '~/api/types/agentConnectTools.ts';

export enum ConnectedAppReservedProviderTypes {
  OAUTH2 = ConnectionTypes.OAUTH
}

export enum ProvideAuthFieldTypes {
  TEXT = 'text',
  SELECT = 'select'
}

export interface SelectFieldOption {
  default?: boolean;
  description?: string;
  displayName: string;
  value: string;
}

export interface ProviderAuthField {
  label: string;
  fieldName: string;
  inputType: ProvideAuthFieldTypes;
  placeholder?: string;
  hint?: string;
  required?: boolean;
  options?: SelectFieldOption[];
}

export interface OauthScopes {
  scope: string;
  displayName?: string;
  description?: string;
  required?: true;
}

export interface ProviderOauthConfig {
  allowAdditionalScopes?: boolean;
  allowUseScalekitCredentials?: boolean;
  availableScopes: OauthScopes[];
}

export type ConnectedAppAuthType = ConnectedAppReservedProviderTypes | string;

export interface ConnectedAppProviderAuthPattern {
  displayName: string;
  description?: string;
  type: ConnectedAppAuthType;
  oauthConfig?: ProviderOauthConfig;
  fields?: ProviderAuthField[];
  accountFields?: ProviderAuthField[];
}

export interface ConnectedAppProvider {
  id: string;
  identifier: string;
  displayName: string;
  authPatterns: ConnectedAppProviderAuthPattern[];
  description?: string;
  categories?: string[];
  iconSrc?: string;
  displayPriority?: number;
  tools?: AgentConnectToolData[];
  comingSoon?: boolean;
}
